/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { createContext, useMemo, useReducer } from 'react';
import { SubmissionInitialState, SubmissionReducer, SubmissionActions } from './SubmissionReducer';

// the submission context holds the current edited submission internal state that is handled by multiple form widgets
export const SubmissionContext = createContext(SubmissionInitialState);

export const SubmissionContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(SubmissionReducer, SubmissionInitialState);

  function addFieldToClear(fieldId) {
    dispatch({
      type: SubmissionActions.ADD_FIELD_TO_CLEAR,
      payload: fieldId,
    });
  }

  function removeFieldToClear(fieldId) {
    dispatch({
      type: SubmissionActions.REMOVE_FIELD_TO_CLEAR,
      payload: fieldId,
    });
  }

  const contextObject = useMemo(
    () => ({
      fieldsToClear: state.fieldsToClear,
      addFieldToClear,
      removeFieldToClear,
    }),
    [state.fieldsToClear],
  );

  return <SubmissionContext.Provider value={contextObject}>{children}</SubmissionContext.Provider>;
};
